import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFirstIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 9,
	viewBox: "0 0 10 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.72667 8.85242L9.66667 7.91242L6.61333 4.85242L9.66667 1.79242L8.72667 0.852417L4.72667 4.85242L8.72667 8.85242Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.33332 8.85242L5.27332 7.91242L2.21998 4.85242L5.27332 1.79242L4.33332 0.852417L0.333316 4.85242L4.33332 8.85242Z",
		fill: "currentColor"
	})]
});
export default SvgFirstIcon;
